import { render, staticRenderFns } from "./airtel.vue?vue&type=template&id=b1252ce2"
import script from "./airtel.vue?vue&type=script&lang=js"
export * from "./airtel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports